
import { toast } from 'react-toastify';
import i18next from 'i18next';

export const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text.toString());
            
      toast.success(i18next.t('pages.customers.modals.resetPasswordCopied'));
    } catch (e) {
        fallbackCopy(text);
    }
};

// Fallback for iOS Safari
const fallbackCopy = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "absolute";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    if (document.execCommand("copy")) {
        toast.success(i18next.t('pages.customers.modals.resetPasswordCopied'));
    } else {
        alert(text);
    }

    document.body.removeChild(textArea);
};
